// extracted by mini-css-extract-plugin
module.exports = {"root":"Actions_root__3A3Pu","action_btn":"Actions_action_btn__1eBeY","--delete":"Actions_--delete__otlmr","--save":"Actions_--save__3WnMm","--send":"Actions_--send__27nef"};